/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserRankingItemFromJSON, UserRankingItemToJSON, } from './UserRankingItem';
/**
 * Check if a given object implements the SeasonRanking interface.
 */
export function instanceOfSeasonRanking(value) {
    if (!('season' in value) || value['season'] === undefined)
        return false;
    if (!('items' in value) || value['items'] === undefined)
        return false;
    return true;
}
export function SeasonRankingFromJSON(json) {
    return SeasonRankingFromJSONTyped(json, false);
}
export function SeasonRankingFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'season': json['season'],
        'items': (json['items'].map(UserRankingItemFromJSON)),
    };
}
export function SeasonRankingToJSON(json) {
    return SeasonRankingToJSONTyped(json, false);
}
export function SeasonRankingToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'season': value['season'],
        'items': (value['items'].map(UserRankingItemToJSON)),
    };
}
